import * as Yup from 'yup';

export const createTopicValidationSchema = () => {
  return Yup.object().shape({
    description: Yup.string().required('Post description is required'),
  });
};

export const createPollValidationSchema = (isEndDateEnabled: boolean) => {
  return Yup.object().shape({
    questionTitle: Yup.string().required('Question title is required'),
    questionDescription: Yup.string().required(
      'Question description is required',
    ),
    pollOptions: Yup.array().of(
      Yup.string().required('Poll option is required'),
    ),
    endDate: isEndDateEnabled
      ? Yup.date()
          .required('End date is required')
          .min(new Date(), 'End date must be in the future')
      : Yup.date().nullable(),
  });
};

export const createMeetingValidationSchema = () => {
  return Yup.object().shape({
    meetingTitle: Yup.string().required('Meeting title is required'),
    meetingDescription: Yup.string().required(
      'Meeting description is required',
    ),
    communities: Yup.array()
      .of(Yup.string())
      .min(1, 'At least one community required'),
    category: Yup.string().required('Category is required'),
    date: Yup.string().required('Date is required'),
    time: Yup.string().required('Time is required'),
    location: Yup.string().required('Location is required'),
  });
};
